import LoginLayout from 'src/modules/layout/login-layout';
import AccessDenied from 'src/modules/login/access-denied';

const AccessDeniedContainer = () => {
	return (
		<LoginLayout>
			<AccessDenied />
		</LoginLayout>
	);
};

export default AccessDeniedContainer;
